import React, { Component } from 'react'
import PropTypes from 'prop-types'
import v4 from 'uuid/v4'

class AgendaSingleItemRegistrationUrl extends Component {

	isPostRegistrationUrlNumber = (link) => {
		try {
			return (link && Number.isInteger(parseInt(link.replace('tel:','').trim())))
		} catch (error) {
			return false
		}
	}

	isPostRegistrationUrlMail = (link) => {
		try {
			return link && link.indexOf('@') >= 0
		} catch (error) {
			return false
		}
	}

	isInternalLink = (link) => {
		try {
			if (!link) return false
			const url = link.trim()
			return url.startsWith('/') || url.startsWith('#') || url.startsWith('?')
		} catch (error) {
			return false
		}
	}

	getPostRegistrationUrlLabel = (link) => {
		try {
			if (link) {
				if (this.isPostRegistrationUrlNumber(link)) {
					return "Tél: "+link.replace('tel:','').trim()
				} else if(this.isPostRegistrationUrlMail(link)) {
					return "Contact mail"
				} else {
					return "S'inscrire / réserver"
				}
			}
			return ''
		} catch (error) {
			return ''
		}
	}

	getPostRegistrationUrlLink = (link) => {
		try {
			if (link) {
				if (this.isPostRegistrationUrlNumber(link)) {
					return "tel:" + link.replace('tel:','').trim()
				} else if (this.isPostRegistrationUrlMail(link)) {
					return "mailto:" + link.replace('mailto:','').trim()
				} else {
					return link.trim()
				}
			}
			return ''
		} catch (error) {
			return ''
		}
	}

	getPostRegistrationUrl = () => {
		try {
			if (this.props.postItem && 
				this.props.postItem._source && 
				this.props.postItem._source.post_registration_url) {
				return this.props.postItem._source.post_registration_url
			}
			return ''
		} catch (error) {
			return ''
		}
	}

	render = () => {
		try {
			const registrationUrl = this.getPostRegistrationUrl()
			if (!registrationUrl) {
				return null
			}

			const listLink = String(registrationUrl).split(',')
			
			return (
				<p 
					className="agenda-single-item-field agenda-single-item-registration-url"
					role="region"
					aria-label="Liens d'inscription et de réservation"
					aria-describedby="registration-description"
				>
					<div id="registration-description" className="sr-only">
						Liens pour s'inscrire ou réserver à cet événement
					</div>
					<span className="agenda-single-item-field-label agenda-single-item-registration-url-label">
						Pour plus d'infos:
					</span>
					{listLink.length > 0 && listLink.map((link, index) => {
						const cleanLink = link.trim()
						if (!cleanLink) return null
						
						const href = this.getPostRegistrationUrlLink(cleanLink)
						const label = this.getPostRegistrationUrlLabel(cleanLink)
						const isInternal = this.isInternalLink(cleanLink)
						
						return (
							<a 
								key={v4()} 
								className="agenda-single-item-field-link" 
								href={href}
								target={isInternal ? undefined : "_blank"}
								rel={isInternal ? undefined : "noopener noreferrer"}
								aria-label={`${label} - ${isInternal ? 'lien interne' : 'lien externe'}`}
							>
								{label}
							</a>
						)
					})}
				</p>
			)
		} catch (error) {
			console.error("Error rendering AgendaSingleItemRegistrationUrl:", error)
			return null
		}
	}
}

AgendaSingleItemRegistrationUrl.propTypes = {
	postItem: PropTypes.shape({
		_source: PropTypes.shape({
			post_registration_url: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.number
			])
		})
	})
}

AgendaSingleItemRegistrationUrl.defaultProps = {
	postItem: null
}

export default AgendaSingleItemRegistrationUrl;